var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRewardPoint = function SvgRewardPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#103976",
    d: "M9.998 17.848c-4.333 0-7.85-3.525-7.85-7.85s3.517-7.85 7.85-7.85 7.85 3.525 7.85 7.85-3.525 7.85-7.85 7.85m0-14.375A6.526 6.526 0 0 0 3.482 9.99a6.526 6.526 0 0 0 6.516 6.517 6.526 6.526 0 0 0 6.517-6.517 6.526 6.526 0 0 0-6.517-6.517"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#103976",
    d: "m11.533 8.441 1.692.217c.375.05.524.5.266.767l-1.2 1.208a.45.45 0 0 0-.125.4l.317 1.675a.457.457 0 0 1-.65.492l-1.517-.767a.48.48 0 0 0-.425 0L8.4 13.25a.454.454 0 0 1-.667-.467L7.99 11.1a.44.44 0 0 0-.133-.4L6.616 9.533a.45.45 0 0 1 .242-.775l1.683-.275a.44.44 0 0 0 .334-.25L9.6 6.69a.456.456 0 0 1 .816-.016l.775 1.516c.067.134.2.225.342.242z"
  })));
};
export default SvgRewardPoint;